// extracted by mini-css-extract-plugin
export default {"root":"PunchupFeed_root__S-0B1"};